// extracted by mini-css-extract-plugin
module.exports = {"helper-boxes":"j5uaI","box":"dNdUj","image":"_3q_RU","content":"_3y3O6","heading":"_3A0yG","text":"_1xddR","button-wrapper":"_3k2qH","button":"_1diFh"};